import { render, staticRenderFns } from "./LinksSegment.vue?vue&type=template&id=2c790906&"
import script from "./LinksSegment.vue?vue&type=script&lang=js&"
export * from "./LinksSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports